<template lang="pug">
  v-container
    v-card.pointer( v-if="!loading" v-for="project in projects" :key="project.id" class="mx-auto mb-1 pointer" max-width="400" @click.native="goToProject(project)" )
      v-card-title {{ project.name }}
        v-icon.ml-2( v-if="isMerch" @click.stop="loadAllData(project)" ) mdi-download-circle-outline
    v-card( v-if="loading" class="mx-auto" flat max-width="50" )
      v-progress-circular( :size="50" color="primary" indeterminate )
    v-card( v-if="error" class="mx-auto" max-width="400" )
      v-card-title Что-то пошло не по плану
        v-spacer
        v-icon( color="red" ) mdi-alert
      v-card-subtitle {{ error }}
    v-dialog( v-model="loadingReport" width="unset" :persistent="loadingReport" )
      v-card
        v-card-title Загрузка отчетов...
        v-card-text( v-if="loadingReport" )
          v-progress-linear( color="deep-purple accent-4" indeterminate rounded height="6" )
</template>


<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import dataService from "../../../_services/dataService";

export default {
  data: () => ({
    projects:[],
    loading:false,
    error: null,
    countUnsyncReport: 0,
    loadingReport: false
  }),

  mounted() {
    this.loadProjects()
  },

  computed: {
    ...mapState("project", ["selectedProject"]),
    ...mapGetters('user', ['checkRole']),

    isMerch() {
      return this.checkRole(1)
    },

  },

  methods: {
    ...mapMutations(['setAppBarTitle']),
    ...mapMutations("project", ["setSelectedProject"]),

    async loadAllData(project) {
      this.loadingReport = true
      await dataService.prefetchAll(project.id).finally(() => {
        this.loadingReport = false
      })
    },
    
    async loadProjects(){
      this.loading = true
      this.setAppBarTitle('loading')
      await dataService.getProjects()
        .then(data => {
          this.projects = data
          this.loading = false
          this.setAppBarTitle('Проекты')
        })
        .catch(error => {
          this.loading = false
          this.error = error
          this.setAppBarTitle(this.error)
        })
    },

    goToProject(p){
      this.setSelectedProject(p)
      this.$router.push(`/project/${p.id}`)
    }
  }
}
</script>